export default {
    // tw: remove decks. we don't use them.
};
